import {App, AppStub, isStubAppData} from '@web-catalog/types';

import {isHiddenApp} from '../appStateUtils';
import {logTmrEvent} from './logEvent';
import {ScreenName} from './logEvents.entity';

type LogRecommendedAppClickProps = {
  mainApp: App | AppStub;
  clickedAppId: string;
  clickedAppPosition: number;
  fromRecommendationsScreen: boolean;
  screenName: ScreenName;
  compilation_framework_type?: string;
};

export const getIsStubValue = (app: App | AppStub): number => {
  /**
   * 0 - приложение есть в сторе
   * 1 - приложения нет в сторе (заглушка)
   * 2 - отсутствующее приложение
   */
  if (isStubAppData(app)) {
    // eslint-disable-next-line no-magic-numbers
    return 2;
  }

  if (isHiddenApp(app)) {
    return 1;
  }

  return 0;
};

export const getFakeRecommendationsFromCompilationParams = (
  fromRecommendationsScreen: boolean,
) => ({
  compilation_id: [
    'app_compilation_PoPrds5',
    fromRecommendationsScreen ? 'recommendation' : '',
  ]
    .filter(Boolean)
    .join('_'),
  compilation_name: 'Возможно вам понравится',
  ...(!fromRecommendationsScreen && {
    compilation_num: 1,
  }),
  compilation_type: 'grid',
});

export const hiddenAppLog = {
  openHiddenAppRequestFormClick: (app: App | AppStub) => {
    logTmrEvent({
      logEvent: 'appPage.isAvailability.click',
      params: {
        started_isStub: getIsStubValue(app),
        started_app_id: app.packageName,
      },
    });
  },

  submittedHiddenAppRequest: (app: App | AppStub) => {
    logTmrEvent({
      logEvent: 'appPage.isAvailability.sendEmail',
      params: {
        started_isStub: getIsStubValue(app),
        started_app_id: app.packageName,
      },
    });
  },
  recommendedAppClick: ({
    mainApp,
    clickedAppId,
    clickedAppPosition,
    fromRecommendationsScreen,
    screenName,
    compilation_framework_type,
  }: LogRecommendedAppClickProps) => {
    logTmrEvent({
      logEvent: 'app.select',
      params: {
        ...getFakeRecommendationsFromCompilationParams(
          fromRecommendationsScreen,
        ),
        started_isStub: getIsStubValue(mainApp),
        app_packageName: clickedAppId,
        app_num: clickedAppPosition + 1,
        selected_app_id: clickedAppId,
        started_app_id: mainApp.packageName,
        position: clickedAppPosition + 1,
        app_id: mainApp.packageName,
        screen_name: screenName,
        compilation_framework_type,
      },
    });
  },
};
